import styled from 'styled-components'

import {
  Collapse as C,
} from 'antd'

const { Panel: P } = C

const Panel = styled(P)`

  border-bottom: unset !important;
  border-radius: 4px 4px 4px 4px !important;
  
  .ant-collapse-header {
    color: #fff !important;
  }
  
  .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
    border-radius: 4px 4px 4px 4px !important;
  }

  .ant-collapse-content {
    padding: 0;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lecture {
    padding: 8px 36px;
    font-size: 16px;
    font-weight: 400;
  }

  .lecture:hover {
    cursor: pointer;
    background: #f2f3f5;
  }

  .arrow {
    color: #fff !important;
  }

  &:hover {
    -webkit-box-shadow: 0 0 5px rgba(41,48,59,.5);
    box-shadow: 0 0 5px rgba(41,48,59,.5)

  }
`

export const _CollapseUpload = {
  Panel,
}



// WEBPACK FOOTER //
// ./src/styled/upload.js